"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIPopoverBody;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _sizes = require("HubStyleTokens/sizes");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _PopoverContext = require("../context/PopoverContext");

var Body = _styledComponents.default.div.withConfig({
  displayName: "UIPopoverBody__Body",
  componentId: "r35hcz-0"
})(["background:inherit;padding:", ";", ";"], function (_ref) {
  var flush = _ref.flush,
      popoverUse = _ref.popoverUse;
  if (flush) return '0';
  if (popoverUse === 'longform') return "0 " + _sizes.TOOLTIP_LONGFORM_PADDING + " 1px";
  if (popoverUse === 'shepherd') return _sizes.SHEPHERD_PADDING_Y + " " + _sizes.POPOVER_PADDING_X;
  if (popoverUse.includes('tooltip')) return _sizes.TOOLTIP_PADDING_Y + " " + _sizes.TOOLTIP_PADDING_X;
  return _sizes.POPOVER_PADDING_Y + " " + _sizes.POPOVER_PADDING_X + " 0";
}, function (_ref2) {
  var popoverUse = _ref2.popoverUse;
  if (popoverUse === 'shepherd') return (0, _styledComponents.css)(["border-bottom-left-radius:inherit;border-bottom-right-radius:inherit;"]);
  if (popoverUse.includes('tooltip')) return (0, _styledComponents.css)(["border-radius:inherit;line-height:1.5;"]);
  return null;
});

function UIPopoverBody(_ref3) {
  var className = _ref3.className,
      rest = (0, _objectWithoutProperties2.default)(_ref3, ["className"]);
  return _react.default.createElement(Body, Object.assign({}, rest, {
    className: (0, _classnames.default)('uiPopoverBody private-popover__body', className),
    popoverUse: (0, _react.useContext)(_PopoverContext.PopoverContext).use
  }));
}

UIPopoverBody.propTypes = {
  children: _propTypes.default.node,
  flush: _propTypes.default.bool
};
UIPopoverBody.displayName = 'UIPopoverBody';
module.exports = exports.default;